var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loadingBroadcast)?_c('div',{staticClass:"d-block",staticStyle:{"margin-bottom":"200px"}},[(_vm.type === 'sms')?_c('CreateSMS',{ref:"smsComponent",attrs:{"object":_vm.broadcast}}):_c('CreateEmail',{ref:"emailComponent",attrs:{"object":_vm.broadcast}})],1):_c('div',{staticClass:"text-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }